<template>
    <div>
        <Modal
                :text="modalText"
                id="modal_show1"
        />

        <table class="w-full d-none d-md-table">
            <thead class="bg-lightGray h-11">
            <tr class="font-bold">
                <td class="pl-2">#</td>
                <td class="pl-2">{{ $t('date') }}</td>
                <td class="pl-2">{{ $t('product.count') }}</td>
                <td class="pl-2">{{ $t('inventory.difference') }}</td>
                <td class="pl-2">{{ $t('inventory.responsiblePerson') }}</td>
                <td class="pl-2">{{ $t('inventory.deficit') }}</td>
                <td class="pl-2">{{ $t('inventory.profit') }}</td>
                <td class="pl-2">{{ $t('actions') }}</td>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="inventory of getInventories"
                :key="inventory.id"
                class="h-11"
            >
                <td class="pl-2">{{ inventory.id }}</td>
                <td class="pl-2">{{ dateFormat(inventory.createdAt) }}</td>
                <td class="pl-2">{{ inventory.productAmount }}</td>
                <td class="pl-2" v-if="currency">{{ showCurrencyById(baseCurrencyId, inventory.difference) }}</td>
                <td class="pl-2 text-main font-bold">{{ inventory.person.givenName }} {{ inventory.person.familyName }}</td>
                <td class="pl-2">{{ inventory.deficit }}</td>
                <td class="pl-2">{{ inventory.profit }}</td>
                <td class="pl-2">
                    <img src="/images/read-more.png" alt="" class="h-7 cursor-pointer pr-2"  @click="showInventory(inventory)">
                    <img src="/images/Union.png" alt="" class="h-7 cursor-pointer pl-2" @click="$bvModal.show('delete-inventory-' + inventory.id)">

                    <Modal
                            text="deleteConfirm"
                            ok-text="yes"
                            cancel-text="no"
                            :is-ok-only="false"
                            :context="{name: $t('inventory.title')}"
                            :id="'delete-inventory-' + inventory.id"
                            :on-ok-pressed="() => {makeDelete(inventory.id)}"
                    />
                </td>
            </tr>
            </tbody>
        </table>
        <table class="w-100 d-md-none">
            <tbody
                v-for="inventory of getInventories"
                :key="inventory.id"
                style="height: 50px; border-bottom: 5px solid #444444"
                :class="bgColorDefiner(inventory)"
            >
                <tr>
                    <td class="pl-2 font-weight-bold">#</td>
                    <td>{{ inventory.id }}</td>
                </tr>
                <tr>
                    <td class="pl-2 font-weight-bold">{{ $t('date') }}</td>
                    <td>{{ dateFormat(inventory.createdAt) }}</td>
                </tr>
                <tr>
                    <td class="pl-2 font-weight-bold">{{ $t('product.count') }}</td>
                    <td>{{ inventory.productAmount }}</td>
                </tr>
                <tr>
                    <td class="pl-2 font-weight-bold">{{ $t('inventory.difference') }}</td>
                    <td v-if="currency">{{ showCurrencyById(baseCurrencyId, inventory.difference) }}</td>
                </tr>
                <tr>
                    <td class="pl-2 font-weight-bold">{{ $t('inventory.responsiblePerson') }}</td>
                    <td>{{ inventory.person.givenName }} {{ inventory.person.familyName }}</td>
                </tr>
                <tr>
                    <td class="pl-2 font-weight-bold">{{ $t('inventory.deficit') }}</td>
                    <td>{{ inventory.deficit }}</td>
                </tr>
                <tr>
                    <td class="pl-2 font-weight-bold">{{ $t('inventory.profit') }}</td>
                    <td>{{ inventory.profit }}</td>
                </tr>
                <tr>
                    <td class="pl-2 font-weight-bold">{{ $t('actions') }}</td>
                    <td>
                        <img src="/images/read-more.png" alt="" class="h-7 cursor-pointer pr-2"  @click="showInventory(inventory)">
                        <img src="/images/Union.png" alt="" class="h-7 cursor-pointer pl-2" @click="$bvModal.show('delete-inventory-' + inventory.id)">

                        <Modal
                            text="deleteConfirm"
                            ok-text="yes"
                            cancel-text="no"
                            :is-ok-only="false"
                            :context="{name: $t('inventory.title')}"
                            :id="'delete-inventory-' + inventory.id"
                            :on-ok-pressed="() => {makeDelete(inventory.id)}"
                        />
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import dateFormattingMixin from "@/mixin/dateFormattingMixin";
import currencyFormatMixin from "@/mixin/currencyFormatMixin";
import Modal from "@/components/html/Modal.vue";

export default {
    name: "InventoryListTable",
    components: {Modal},
    mixins: [dateFormattingMixin, currencyFormatMixin],
    data() {
        return {
            modalText: ''
        }
    },
    computed: {
        ...mapGetters(['getInventories']),
    },
    methods: {
        ...mapActions(['fetchInventories', 'deleteInventory', 'setInventoryDetails']),
        makeDelete(id) {
            this.$root.showOverlay = true
            let data = {page: this.$route.params.page ? this.$route.params.page : 1}
            this
                .deleteInventory(id)
                .then(() => {
                    this.$root.showOverlay = false
                    this.fetchInventories(data)
                })
                .catch((reason) => {
                    this.$root.showOverlay = false
                    this.modalText = reason
                    this.$bvModal.show('modal_show1')
                })
        },
        showInventory(inventory) {
            this.setInventoryDetails(inventory)
            this.$i18nHelper.toUrl('inventory/' + inventory.id)
        },
        bgColorDefiner(inventory) {
            return  inventory.isSynced ?
                'height: 50px; border-bottom: 1px solid #444444; background-color: #6ed779' :
                'height: 50px; border-bottom: 1px solid #444444;'
        }
    },
}
</script>

<style scoped>
table tbody tr {
    border-bottom: 1px solid #eaeaea;
}
</style>
